var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.show
      ? _c("div", { staticClass: "modal" }, [
          _c("div", { staticClass: "modal__dialog" }, [
            _c(
              "div",
              { staticClass: "modal__header" },
              [
                _vm._t("header", function () {
                  return [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.iframeTitle) +
                        "\n                "
                    ),
                  ]
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "modal__close",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.closeModal()
                      },
                    },
                  },
                  [_vm._v("\n                    x\n                ")]
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal__body" }, [
              _c("iframe", {
                staticClass: "gpfCls",
                attrs: {
                  id: "quickViewIFrame",
                  width: "100%",
                  height: "100%",
                  src: _vm.quickview,
                },
                on: { load: _vm.load },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }